<div mat-dialog-title class="flex-container">
  <button mat-button class="close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <h1>Add User</h1>
</div>
<div mat-dialog-content>
  <form class="tr" [formGroup]="userForm" novalidate>
    <div class="row">
      <div class="col-lg-6">
        <p>Employee Id</p>
        <mat-form-field appearance="none" class="manage-input">
          <input
            matInput
            formControlName="employeeId"
            placeholder="Employee Id"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <app-input
          label="First Name"
          name="firstName"
          pattern="^(?!\s*$)[^0-9]+"
          placeholder="Enter First Name"
          required="true"
        ></app-input>
      </div>

      <div class="col-lg-6">
        <app-input
          label="Last Name"
          name="lastName"
          pattern="^(?!\s*$)[^0-9]+"
          placeholder="Enter Last Name"
          required="true"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <app-input
          label="Email ID"
          type="email"
          name="email"
          required="true"
          placeholder="Enter Email ID"
          maxlength="101"
        ></app-input>
      </div>

      <div class="col-lg-6">
        <app-input
          label="Phone Number"
          type="tel"
          name="phoneNumber"
          placeholder="Enter Phone Number"
          required="true"
          minlength="10"
          maxlength="10"
          pattern="[0-9]*"
          (input)="deleteUnsupportedChars($event)"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <p>Effective Date<span>*</span></p>
        <mat-form-field appearance="none" class="manage-input">
          <input
            matInput
            [matDatepicker]="effectiveDate"
            placeholder="Effective Date"
            formControlName="effectiveDate"
            [min]="minDate"
            class="new-s"
            (dateChange)="dateChanged($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="effectiveDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #effectiveDate></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-lg-6">
        <p>Termination Date<span>*</span></p>
        <mat-form-field appearance="none" class="manage-input">
          <input
            matInput
            [matDatepicker]="terminationDate"
            placeholder="Termination Date"
            formControlName="terminationDate"
            [min]="maxDate"
            class="new-s"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="terminationDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #terminationDate></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <p>Preferred Time Zone<span>*</span></p>
        <mat-form-field appearance="none" class="manage-select">
          <mat-select
            value="Select Time Zone"
            placeholder="Select Time Zone"
            formControlName="timeZone"
          >
            <mat-option value="3">CST</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6">
        <p>Notification Settings<span>*</span></p>
        <mat-form-field appearance="none" class="manage-select">
          <mat-select
            value="Select OTP Preference"
            placeholder="Select OTP Preference"
            formControlName="otpPreference"
          >
            <mat-option value="1">Email</mat-option>
            <mat-option value="2">SMS</mat-option>
            <mat-option value="3">Email & SMS</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <app-input
          label="Address Line 1"
          name="address1"
          placeholder="Enter Address"
        ></app-input>
      </div>

      <div class="col-lg-6">
        <app-input
          label="Address Line 2"
          name="address2"
          placeholder="Enter Address"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <app-input label="City" name="city"> </app-input>
      </div>

      <div class="col-lg-4">
        <app-input label="State" name="state" (keypress)="keyPress2($event)">
        </app-input>
      </div>

      <div class="col-lg-4">
        <app-input
          label="Zip Code"
          name="zip"
          minlength="5"
          maxlength="5"
          (input)="deleteUnsupportedChars($event)"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <p
        style="
          border-bottom: 1px dotted rgb(191, 196, 197);
          margin: 10px;
          width: 100%;
        "
      >
        &nbsp;
      </p>
    </div>

    <div class="row">
      <div class="col-lg-5">
        <p>Portal Access <span>*</span></p>
        <mat-form-field appearance="none" class="manage-select">
          <mat-select
            value="Select Portal Access"
            placeholder="Select Portal Access"
            (selectionChange)="getRolesByPortal($event)"
            multiple
            required
            formControlName="portals"
          >
            <mat-option
              *ngFor="let portal of portals"
              [disabled]="enableReset"
              [value]="portal.value"
              >{{ portal.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-5">
        <p>User Role <span>*</span></p>
        <mat-form-field appearance="none" class="manage-select">
          <mat-select
            matInput
            formControlName="roles"
            placeholder="Select Role"
            (openedChange)="rolesSelected($event)"
            multiple
            required
          >
            <mat-option
              *ngFor="let role of displayRoles"
              [disabled]="enableReset"
              (onSelectionChange)="showNpForm($event)"
              value="{{ role.id }}"
              >{{ role.role }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-2 container">
        <button
          mat-raised-button
          mat-button
          class="btn btn-icon-text Action-buttons md-button-right top-pad"
          [disabled]="!enableReset"
          (click)="changeResetButton()"
        >
          RESET
        </button>
      </div>
    </div>

    <div *ngIf="salesFormEnabled">
      <div class="row">
        <p style="margin-left: 20px">*Client Sales Details..</p>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-4">
          <p>Client<span>*</span></p>
          <mat-form-field appearance="none" class="manage-select">
            <mat-select
              matInput
              formControlName="clientId"
              placeholder="Select Client"
            >
              <mat-option>Select Client</mat-option>
              <mat-option
                *ngFor="let client of clientsList"
                [value]="client.clientId"
              >
                {{ client.clientName }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Np Selected-->
    <div *ngIf="nursePractitionerFormEnabled">
      <div class="row">
        <p style="margin-left: 20px">
          *Selected Nurse Practitioner please add all mandatory fields..
        </p>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-4">
          <p>Provider Title<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="title"
              placeholder="Provider Title"
              type="text"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-6">
          <p>NPI<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="npi"
              placeholder="NPI"
              (input)="deleteUnsupportedChars($event)"
              minlength="10"
              maxlength="12"
            />
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Licensed State<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="licensedState"
              placeholder="Licensed State"
              (keypress)="keyPress2($event)"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-6">
          <p>Licensed Start Date<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              [matDatepicker]="licensedStartDate"
              formControlName="licensedStartDate"
              placeholder="Lincensed Start Date"
              [max]="maxDate"
              class="new-s"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="licensedStartDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #licensedStartDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Licensed Expiry Date<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              [matDatepicker]="licensedExpiryDate"
              formControlName="licensedExpiryDate"
              placeholder="Lincensed Expiry Date"
              [min]="minDate"
              class="new-s"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="licensedExpiryDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #licensedExpiryDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <p style="margin-left: 20px">Add Service Address</p>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-4">
          <p>Address Line 1<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="serviceAddress1"
              placeholder="Enter Address"
              type="text"
            />
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <p>Address Line 2 <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="serviceAddress2"
              placeholder="Enter Address"
              type="text"
            />
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <p>City<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="serviceCity"
              placeholder="Enter City"
              type="text"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="width: 100%">
        <div class="col-lg-4">
          <p>State<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="serviceState"
              placeholder="Enter State"
              (keypress)="keyPress2($event)"
            />
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <p>Zip Code<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input
              matInput
              formControlName="serviceZip"
              placeholder="Enter ZipCode"
              (input)="deleteUnsupportedChars($event)"
              minlength="5"
              maxlength="5"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <!-- Np Selected Ends-->

    <div class="col-lg-12 toparea">
      <button
        n-submit
        mat-raised-button
        mat-button
        class="btn btn-icon-text Action-buttons md-button-right"
        [disabled]="!userForm.valid"
        (click)="addUser()"
        type="submit"
      >
        ADD USER
      </button>
    </div>
  </form>
</div>
